module.exports = __webpack_public_path__ + "img/DW365-026.d679db39.jpg";